<template>
  <div class="layout">
    <!-- 导航栏 -->
    <nav class="navbar">
      <div class="navbar-container">
        <div class="navbar-logo">
          <img src="@/assets/logo.png" alt="" srcset="">
          <div class="navbar-brand">数据统计</div>
        </div>

        <!-- PC端导航 -->
        <ul class="navbar-nav pc-nav">
          <li class="nav-item">
            <router-link
              to="/"
              class="nav-link"
              active-class="active"
              exact
            >统计</router-link>
          </li>
          <li class="nav-item">
            <router-link
              to="/order-list"
              class="nav-link"
              active-class="active"
            >订单列表</router-link>
          </li>
          <li class="nav-item">
            <router-link
              to="/product-list"
              class="nav-link"
              active-class="active"
            >产品管理</router-link>
          </li>
          <li class="nav-item">
            <router-link
              to="/loan-application"
              class="nav-link"
              active-class="active"
            >贷款审批</router-link>
          </li>
          <li class="nav-item">
            <span
              class="nav-link logout"
              @click="handleLogout"
            ><i class="el-icon-warning" />退出登陆</span>
          </li>
          <!-- <li class="nav-item">
            <router-link
              to="/sales-summary-list"
              class="nav-link"
              active-class="active"
            >销售汇总</router-link>
          </li> -->
        </ul>
        <!-- 导航栏分隔线 -->
        <div class="nav-line" />
        <!-- 企业切换区域 -->
        <div class="enterprise-wrapper" @click="toggleEnterpriseMenu">
          <div class="enterprise-info">
            <div class="enterprise-avatar">
              <img
                v-if="currentEnterprise.image"
                :src="currentEnterprise.image"
                :alt="currentEnterprise.name"
              >
              <div v-else class="avatar-placeholder">
                {{ currentEnterpriseInitial }}
              </div>
            </div>
            <span class="enterprise-name">{{
              currentEnterprise.shortName ||
                currentEnterprise.enterpriseName ||
                '选择企业'
            }}</span>
            <img
              class="switch-icon"
              src="@/assets/switch.png"
              alt=""
              srcset=""
            >
            <!-- <i
              class="el-icon-caret-bottom"
              style="margin-left: 5px; font-size: 12px"
            /> -->
          </div>
        </div>

        <!-- 企业切换抽屉 -->
        <div :class="['enterprise-drawer', { show: showEnterpriseMenu }]">
          <div class="drawer-header">
            <div style="display: flex; align-items: center">
              <h3>选择企业</h3>
              <el-button
                style="margin-left: 10px"
                type="primary"
                size="medium"
                icon="el-icon-refresh"
                circle
                @click="refreshEnterprise"
              />
            </div>

            <i
              class="el-icon-close drawer-close"
              @click="toggleEnterpriseMenu"
            />
          </div>
          <div v-loading="loading" class="drawer-content">
            <div
              v-for="(enterprise, index) in enterprises"
              :key="index"
              class="enterprise-item"
              :class="{ active: currentEnterprise.id === enterprise.id }"
              @click="handleSwitchEnterprise(enterprise)"
            >
              <div class="enterprise-item-avatar">
                <!-- <img :src="enterprise.image" :alt="enterprise.name"> -->
                {{
                  (enterprise.shortName || enterprise.enterpriseName)
                    | firstEnterpriseInitial
                }}
              </div>
              <div class="enterprise-item-info">
                <div class="enterprise-item-name">
                  {{ enterprise.shortName || enterprise.enterpriseName }}
                </div>
                <div class="enterprise-item-code">
                  {{ enterprise.province || '' }}{{ enterprise.city || ''
                  }}{{ enterprise.area || '' }}
                </div>
              </div>
              <i
                v-if="currentEnterprise.id === enterprise.id"
                class="el-icon-check enterprise-item-check"
              />
            </div>
          </div>
        </div>
        <!-- 抽屉遮罩 -->
        <div
          v-if="showEnterpriseMenu"
          class="drawer-mask"
          @click="toggleEnterpriseMenu"
        />

        <!-- 手机端导航按钮 -->
        <div class="mobile-nav-btn" @click="toggleMobileMenu">
          <img src="@/assets/menu.png" alt="" srcset="">
        </div>
      </div>

      <!-- 手机端导航菜单 -->
      <div :class="['mobile-nav-menu', { show: showMobileMenu }]">
        <ul class="mobile-nav-list">
          <li class="mobile-nav-item" @click="toggleMobileMenu">
            <router-link
              to="/"
              class="mobile-nav-link"
              active-class="active"
              exact
            >首页</router-link>
          </li>
          <li class="mobile-nav-item" @click="toggleMobileMenu">
            <router-link
              to="/order-list"
              class="mobile-nav-link"
              active-class="active"
            >订单列表</router-link>
          </li>
          <li class="mobile-nav-item" @click="toggleMobileMenu">
            <router-link
              to="/product-list"
              class="mobile-nav-link"
              active-class="active"
            >产品管理</router-link>
          </li>
          <li class="mobile-nav-item" @click="toggleMobileMenu">
            <router-link
              to="/loan-application"
              class="mobile-nav-link"
              active-class="active"
            >贷款审批</router-link>
          </li>
          <!-- <li class="mobile-nav-item" @click="toggleMobileMenu">
            <router-link
              to="/sales-summary-list"
              class="mobile-nav-link"
              active-class="active"
            >销售汇总</router-link>
          </li> -->
          <li class="mobile-nav-item" @click="handleLogout">
            <div class="mobile-nav-link logout">
              <i class="el-icon-switch-button" /> 退出登录
            </div>
          </li>
        </ul>
      </div>
    </nav>

    <!-- 主内容区域 -->
    <main class="main-content">
      <keep-alive :include="['OrderList']">
        <router-view :key="$route.fullPath" />
      </keep-alive>
    </main>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
export default {
  name: 'Layout',
  data() {
    return {
      showMobileMenu: false,
      showEnterpriseMenu: false,
      loading: false
    };
  },
  computed: {
    ...mapGetters(['userInfo', 'enterprises', 'currentEnterprise']),
    // 当前企业首字母
    currentEnterpriseInitial() {
      const name =
        this.currentEnterprise.shortName ||
        this.currentEnterprise.enterpriseName;
      if (name) {
        return name.charAt(0).toUpperCase();
      }
      return 'E';
    }
  },
  filters: {
    firstEnterpriseInitial(name) {
      return name ? name.charAt(0).toUpperCase() : 'E';
    }
  },
  created() {},
  methods: {
    ...mapActions(['logout', 'switchEnterprise', 'refreshEnterpriseList']),
    toggleMobileMenu() {
      this.showMobileMenu = !this.showMobileMenu;
      // 关闭企业菜单
      this.showEnterpriseMenu = false;
    },
    // 刷新企业列表
    async refreshEnterprise() {
      try {
        this.loading = true;
        await this.refreshEnterpriseList();
        this.loading = false;
      } catch (error) {
        this.loading = false;
      }
    },
    // 切换企业菜单显示
    toggleEnterpriseMenu() {
      this.showEnterpriseMenu = !this.showEnterpriseMenu;
      // 关闭移动端菜单
      this.showMobileMenu = false;
    },
    // 切换企业
    handleSwitchEnterprise(enterprise) {
      this.switchEnterprise(enterprise);
      this.showEnterpriseMenu = false;
      // 这里可以添加切换企业后的逻辑，如重新加载数据等
      console.log('切换到企业:', enterprise.name);
    },
    // 退出登录
    handleLogout() {
      this.$confirm('确定退出登录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.logout();
          this.$router.push('/login');
          // 关闭菜单
          this.showMobileMenu = false;
          this.showEnterpriseMenu = false;
        })
        .catch(() => {
          // 取消退出登录
        });
    }
  }
};
</script>

<style scoped>
.layout {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  /* overflow: hidden; */
}

/* 导航栏样式 */
.navbar {
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 100;
}

.navbar-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
}
.navbar-logo {
  display: flex;
  align-items: center;
}
.navbar-logo img {
  width: 40px;
  height: 40px;
  margin-right: 10px;
}
.navbar-brand {
  font-size: 18px;
  font-weight: bold;
  color: #5470c6;
}

/* PC端导航 */
.pc-nav {
  display: flex;
  list-style: none;
  gap: 20px;
  margin-left: auto;
}

.nav-item {
  position: relative;
}

.nav-link {
  text-decoration: none;
  color: #666;
  font-size: 14px;
  font-weight: 500;
  padding: 8px 12px;
  border-radius: 4px;
  transition: all 0.3s;
}

.nav-link:hover {
  color: #5470c6;
  background-color: #f0f0f0;
}

.nav-link.active {
  color: #5470c6;
  background-color: #e6f0ff;
}
.nav-line {
  width: 1px;
  height: 24px;
  background-color: #e5e5e5;
  margin: 0 10px;
}
.nav-item .logout {
  color: #f56c6c;
  cursor: pointer;
}
/* 企业切换区域 */
.enterprise-wrapper {
  position: relative;
  margin-right: 10px;
  cursor: pointer;
}

.enterprise-info {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  border-radius: 20px;
  transition: all 0.3s ease;
  font-size: 14px;
  color: #333;
  font-weight: 500;
}

.enterprise-info:hover {
  background-color: #f0f0f0;
}

/* 企业头像 */
.enterprise-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  overflow: hidden;
  background-color: #5470c6;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 14px;
  font-weight: bold;
}

.enterprise-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* 企业名称 */
.enterprise-name {
  font-size: 14px;
  color: #333;
  font-weight: 500;
}
.switch-icon {
  width: 20px;
  height: 20px;
}
/* 企业切换抽屉 */
.enterprise-drawer {
  position: fixed;
  top: 0;
  right: -320px;
  width: 320px;
  height: 100vh;
  background-color: #fff;
  box-shadow: -4px 0 12px rgba(0, 0, 0, 0.15);
  z-index: 300;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.enterprise-drawer.show {
  right: 0;
}

/* 抽屉遮罩 */
.drawer-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 299;
  transition: all 0.3s ease;
}

/* 抽屉头部 */
.drawer-header {
  padding: 20px;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 18px;
  font-weight: bold;
  color: #333;
}

.drawer-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: bold;
  color: #333;
}

.drawer-close {
  font-size: 20px;
  color: #999;
  cursor: pointer;
  transition: all 0.3s ease;
}

.drawer-close:hover {
  color: #333;
}

/* 抽屉内容 */
.drawer-content {
  flex: 1;
  overflow-y: auto;
  padding: 10px 0;
}

/* 企业列表项 */
.enterprise-item {
  display: flex;
  align-items: center;
  padding: 16px 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
}

.enterprise-item:hover {
  background-color: #f5f7fa;
}

.enterprise-item.active {
  background-color: #e6f0ff;
  color: #5470c6;
}

/* 企业项头像 */
.enterprise-item-avatar {
  width: 48px;
  height: 48px;
  border-radius: 8px;
  overflow: hidden;
  margin-right: 16px;
  text-align: center;
  line-height: 48px;
  font-size: 16px;
  font-weight: 500;
  color: #fff;
  background-color: #5470c6;
}

.enterprise-item-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* 企业项信息 */
.enterprise-item-info {
  flex: 1;
  min-width: 0;
}

.enterprise-item-name {
  font-size: 16px;
  font-weight: 500;
  color: #333;
  margin-bottom: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.enterprise-item.active .enterprise-item-name {
  color: #5470c6;
}

.enterprise-item-code {
  font-size: 12px;
  color: #999;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.enterprise-item.active .enterprise-item-code {
  color: #85a5ff;
}

/* 选中标记 */
.enterprise-item-check {
  font-size: 18px;
  color: #5470c6;
  margin-left: auto;
}

/* 手机端导航按钮 */
.mobile-nav-btn {
  display: none;
  cursor: pointer;
}
.mobile-nav-btn img {
  width: 24px;
  height: 18px;
}
/* 退出登录按钮（移动端） */
.mobile-nav-link.logout {
  color: #f56c6c;
  /* display: flex; */
  align-items: center;
  gap: 8px;
}

.mobile-nav-link.logout:hover {
  background-color: #fff2f0;
  color: #f56c6c;
}

.mobile-nav-link.logout i {
  margin-right: 0;
}

/* 手机端导航菜单 */
.mobile-nav-menu {
  background-color: #fff;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  position: fixed;
  top: 60px;
  bottom: 0;
  left: 140px;
  right: 0;
  z-index: 10;
  transform: translateX(100%);
  /* opacity: 0; */
  transition: all 0.2s;
}

.mobile-nav-menu.show {
  transform: translateX(-0);
  opacity: 1;
}

.mobile-nav-list {
  list-style: none;
  padding: 10px 0;
}

.mobile-nav-item {
  text-align: center;
}

.mobile-nav-link {
  display: block;
  text-decoration: none;
  color: #666;
  font-size: 14px;
  font-weight: 500;
  padding: 12px 20px;
  transition: all 0.3s;
}

.mobile-nav-link:hover {
  background-color: #f0f0f0;
  color: #5470c6;
}

.mobile-nav-link.active {
  background-color: #e6f0ff;
  color: #5470c6;
}

/* 主内容区域 */
.main-content {
  /* height: calc(100% - 60px); */
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 10px 0 0 0;
  box-sizing: border-box;
  /* overflow-y: auto;
  overflow-x: hidden;
  position: relative; */
}

/* 响应式设计 */
@media (max-width: 768px) {
  .pc-nav {
    display: none;
  }
  .nav-line {
    display: none;
  }

  .mobile-nav-btn {
    display: flex;
  }

  .mobile-nav-menu {
    display: block;
  }

  .navbar-container {
    padding: 0 15px;
  }

  .navbar-brand {
    font-size: 16px;
  }

  .main-content {
    padding: 10px 0;
  }

  .enterprise-wrapper {
    margin-left: auto;
    margin-right: 20px;
  }
  .enterprise-avatar {
    display: none;
  }
  .enterprise-wrapper::after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    margin: auto 0;
    width: 1px;
    height: 20px;
    background-color: #999;
  }
}

@media (max-width: 480px) {
  .main-content {
    padding: 10px;
  }
}
</style>
